/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Einvoice_Reference_UnknownInputs */

const vi_einvoice_reference_unknown = /** @type {(inputs: Einvoice_Reference_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`MISA ghi nhận liên kết hóa đơn (loại ${i?.code}).`)
};

/**

* @param {Einvoice_Reference_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_reference_unknown = /** @type {((inputs: Einvoice_Reference_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Reference_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_reference_unknown(inputs)
});